<template>
  <div class="afdc-row afdc-no-gutters afdc-form-group">
    <div class="afdc-col-md-7 afdc-location-inputs-col" id="afdc-nps-select-group">
      <div class="afdc-custom-control afdc-custom-checkbox afdc-nps-checkbox">
        <input type="checkbox" class="afdc-custom-control-input" v-model="showParks" :id="'parkShowCheck'" >
        <label class="afdc-custom-control-label" :for="'parkShowCheck'">{{ $t('Show park boundaries') }}</label>
      </div>
      <label class="afdc-sr-only" for="afdc-park-select">{{ $t('National Parks') }}</label>
      <div class="afdc-dropdown afdc-search-select-dropdown" v-on-clickaway="close">
        <div tabindex=0 @keyup.space="toggle" role="button" class="afdc-custom-select" @click="toggle" id="afdc-nps-select" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="show ? 'true' : 'false'"> {{ selectedParkName }} </div>
        <div v-bind:class="{ 'afdc-dropdown-menu': true, 'afdc-show': show }" aria-labelledby="afdc-nps-select">
          <div class="afdc-nps-input-container">
            <input class="afdc-nps-input afdc-clearable-input" type="text" v-model="searchQuery" placeholder="Search for park" />
            <div v-if="searchQuery" class="afdc-clear-input" v-on:click="clearQuery">
              <span class="afdc-sr-only">{{ $t('Clear location') }}</span>
              <font-awesome-icon icon="times-circle" class="afdc-fa-icon"/>
            </div>
          </div>
          <div class="afdc-custom-radio-container">
            <div v-if="filteredPark.length > 0">
              <label class="afdc-custom-radio-label" :class="{'afdc-active-park': isActivePark(park.id)}" v-for="park in filteredPark" :key="park.id" @click="selectPark(park)">
                <input type="checkbox" class="afdc-custom-radio-input" :value="park.id" v-model="selectedParkId" :id="'afdc-search-select-' + park.id">
                <div class="afdc-custom-radio-design"></div>
                <div class="afdc-custom-radio-text">{{ park.name }} <span class="afdc-count-text">(<em>{{ singleStationCountText(park.station_count) }}</em>)</span></div>
              </label>
            </div>
            <div v-else class="afdc-park-name-error">
              <p>{{ $t('No park names match your search') }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="afdc-col-md-5 afdc-location-inputs-col">
      <label class ="afdc-col-form-label" for="afdc-find-status">{{ $t("Status") }}</label>
      <select-multiple-dropdown v-model="queryStatus" v-bind:options="statusOptions" id="afdc-find-status"/>
    </div>
  </div>
</template>

<script>
import SelectMultipleDropdown from '@/components/SelectMultipleDropdown.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'NpsFilter',
  components: {
    SelectMultipleDropdown,
  },
  mixins: [clickaway],
  data() {
    return {
      searchQuery: '',
      selectedParkId: [],
      selectedParkName: '',
      randomSelect: '',
      show: false,
    };
  },
  watch: {
    parkId: {
      immediate: true,
      handler: 'setSelectedPark',
    },
    selectedLocation: 'checkLocation',
    parkGeo: {
      immediate: true,
      handler: 'setSelectedPark',
    },
  },
  methods: {
    setSelectedPark() {
      const parkGeo = {
        type: 'FeatureCollection',
        features: [],
      };
      const parkId = this.parkId.toString();
      if (parkId !== 'all') {
        const filteredPark = this.$store.getters.getNpsBoundaries.features.filter((park) => park.properties.id.toString() === parkId);
        parkGeo.features = filteredPark;
        if (filteredPark.length > 0) {
          this.selectedParkName = filteredPark[0].properties.unit_name;
          this.$router.push({
            name: this.$store.getters.getNavActiveFilterRouteName,
            query: { ...this.$store.getters.getFilters, ids: filteredPark[0].properties.equipment_ids, location: undefined },
          });
        }
      } else {
        this.selectedParkName = 'All parks';
        this.$router.push({
          name: this.$store.getters.getNavActiveFilterRouteName,
          query: { ...this.$store.getters.getFilters, ids: 'all' },
        });
      }
      this.selectedParkId = [parkId];
      this.$store.commit('setSelectedPark', parkGeo);
    },
    selectPark(park) {
      this.$router.push({
        name: this.$store.getters.getNavActiveFilterRouteName,
        query: { ...this.$store.getters.getFilters, park_id: park.id },
      });
      this.show = false;
      this.searchQuery = '';
    },
    isActivePark(parkId) {
      const parkMatch = parkId === this.selectedParkId[0];
      const onePark = this.filteredPark.length === 1;
      return parkMatch || onePark;
    },
    toggle() {
      this.show = !this.show;
    },
    close() {
      this.show = false;
    },
    clearQuery() {
      this.searchQuery = '';
    },
    singleStationCountText(count) {
      const text = this.$ngettext('%s station', '%s stations', count);
      return this.$sprintf(text, this.$formatNumber(count));
    },
    isAll(parkId) {
      return parkId === 'all';
    },
    checkLocation() {
      const location = this.selectedLocation;
      const parkGeo = {
        type: 'FeatureCollection',
        features: [],
      };
      if (location !== undefined) {
        this.$router.push({
          name: this.$store.getters.getNavActiveFilterRouteName,
          query: { ...this.$store.getters.getFilters, ids: 'all', park_id: 'all' },
        });
        this.selectedParkId = ['all'];
        this.$store.commit('setSelectedPark', parkGeo);
      }
    },
  },
  computed: {
    selectedLocation() {
      return this.$store.getters.getFilterValueWithDefault('location');
    },
    parkGeo() {
      return this.$store.getters.getNpsBoundaries;
    },
    parkId() {
      return this.$store.getters.getFilterValueWithDefault('park_id');
    },
    selectedParkStore() {
      return this.$store.getters.getSelectedPark;
    },
    queryEvLevels: syncInputRouteQuery('ev_levels'),
    queryStatus: syncInputRouteQuery('status'),

    levelOptions() {
      const options = this.$store.getters.loaderElecLevels;
      return options.filter((option) => option.key !== 'legacy');
    },

    statusOptions() {
      return this.$store.getters.loaderStatusTypes;
    },

    filteredPark() {
      const query = this.searchQuery.toLowerCase();
      if (this.searchQuery === '') {
        return this.parks;
      } return this.parks.filter((park) => Object.values(park).some((word) => String(word).toLowerCase().includes(query)));
    },

    showParks: {
      get() {
        return this.$store.getters.getNpsBoundaryCheck;
      },
      set(value) {
        this.$store.commit('setNpsBoundaryCheck', value);
      },
    },
    parks() {
      return this.$store.getters.getNpsFilterValues;
    },
  },
};
</script>
<style lang="scss">
  .nps-checkbox {
    margin: 5px 0 7px 0;
  }

  .search-select-dropdown {
    .custom-radio-container {
      max-height:250px;
      overflow-y: scroll;
      padding: 0 8px;

      p {
        line-height: 1;
      }
    }
    .custom-radio-label {
      display: flex;
      align-items: center;
      padding: 5px;
      margin: 3px 0;
      cursor: pointer;
    }
    .active-park,
    .custom-radio-label:hover,
    .custom-radio-label:focus-within {
      background: #258AF7;
      color: #fff;
    }
    .custom-radio-input {
      width: 1px;
      opacity: 0;
      z-index: -1;
    }

    .clear-input {
      right: 18px;
    }
    .custom-radio-design {
      width: 5%;
      margin-right: 5px ;
      height: 20px;
      display: flex;
      align-items: center;
    }
    .custom-radio-input:checked+.custom-radio-design::before {
      content: '\2713';
    }
    .custom-radio-text {
      width: 95%;
      line-height: 115%;
    }
    .count-text {
      display: inline;
      font-size: 12px;
    }
  }

  .search-select-dropdown {
    max-width: 365px;
    .custom-select {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .nps-input-holder {
    position: relative;
    height: 45px;
    width: 100%;
    background: #fff;
    max-width: inherit;
    display: flex;
    justify-content: center;
  }

  .nps-input-container {
    position: sticky;
    display: flex;
    justify-content: center;
    padding-bottom: 5px;
    background: #fff;
  }
  .nps-input {
    width: 90%;
    height: 40px;
    border: 2px solid lightgrey;
    padding-left: 8px;
    background: #fff;
  }
  .nps-options {
    width: 100%;
    ul {
      list-style: none;
      text-align: left;
      padding-left: 8px;
      max-height: 175px;
      overflow-y: scroll;
      overflow-x: hidden;
    }
    li {
      width: 100%;
      padding: 6px;
      cursor: pointer;
      &:hover {
        background-color: #70878a;
      }
    }
  }

</style>
